import { defaultAxios, IParams } from '../base';

export interface IMutateHouseCert extends IParams {
  // todo parameter 추가 예정
}

// 주담대 본인 인증 요청
export const mutateHouseCert = async (params: IMutateHouseCert) => {
  return await defaultAxios().put(`/house/cert`, params);
};
